import type { Vector2 } from "./geometry";

export class MiterSourceNode {
  position: Vector2;
  connections: MiterSourceNode[];

  constructor(position: Vector2) {
    this.position = { x: position.x, y: position.y };
    this.connections = [];
  }
}
